<template>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
    style="max-width: 580px"
    id="info-modal"
    role="document"
  >
    <div class="modal-content modal-y-content ">
      <div class="modal-header">
        <h5 v-if="!clientItem" class="modal-title">{{ content.title }}</h5>
        <h5 v-else class="modal-title">{{ clientItem.name }}</h5>
        <a
          class="btn btn-custom light-o"
          data-dismiss="modal"
          @click="closeModal()"
        >
          <i class="fa fa-times-circle"></i>
        </a>
      </div>
      <div class="modal-body p-0">
        <div class="content p-3">
          <div class="mb-1">
            <div v-if="!clientItem" v-html="content.description"></div>
            <div v-else>
              <center>
                <h5>Clients:</h5>
                <select
                  class="custom-select"
                  v-model="selectedClient"
                  @change="text = ''"
                >
                  <option
                    v-for="(item, index) in clientItem.clients"
                    :key="item.id"
                    :value="index"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="copyIframeCode(clientItem.clients[selectedClient])"
                >
                  Copy Iframe Code For Selected Client
                </button>

                <p v-show="showText">{{ text }}</p>
              </center>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dialog",
  data() {
    return {
      selectedClient: 0,
      showText: false,
      text: ""
    };
  },
  methods: {
    closeModal() {
      this.showText = false;
      window.$("#computedInfo").modal("hide");
    },
    copyIframeCode(client) {
      let iframeLink =
        '<iframe src="' +
        process.env.VUE_APP_ROOT_PATH +
        "iframe/" +
        this.clientItem.id +
        "?clientID=" +
        client.id +
        '" width="100%" scrolling="no" id="arxiframe" style="border: none" frameborder="0"></iframe>' +
        '<script type="text/javascript" src="' +
        process.env.VUE_APP_ROOT_PATH +
        'js/arxiframe.js"></scr' +
        "ipt>";
      const el = document.createElement("textarea");
      el.value = iframeLink;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);

      this.text = `Iframe code for ${client.name} has been copied to the clipboard.`;
      this.showText = true;
    }
  },
  props: {
    content: {
      title: "",
      description: ""
    },
    clientItem: {} //used for client modals in FormsList component
  }
};
</script>

<style scoped>
button {
  display: block;
  margin-top: 20px;
}

p {
  margin-top: 20px;
}

select {
  width: 80%;
  
}
.modal-y-content {
  position: absolute !important;
  top: 200px !important;
}
</style>
